<app-content-modal [title]="'TWO_FACTOR.SET_CODE.WRITE_CODE'" [buttons]="buttons" [hideClose]="maxTriesExceeded">
  <img src="assets/imgs/employee-portal/codigo_sms.svg" class="base-modal__image image-code-validation" />
  <p class="base-modal__description" [innerHtml]="'TWO_FACTOR.SET_CODE.INFO' | mTranslate"></p>

  @if (showCodeValidationForm()) {
    <form [formGroup]="form">
      <m-input
        class="custom-formfield-input"
        formControlName="code"
        minlength="6"
        maxlength="6"
        [label]="'TWO_FACTOR.TYPE_CODE.KEY' | mTranslate"
        (keydown.enter)="validateCode()" />
      @if (form.controls.code.hasError('invalidCode')) {
        <p class="code-validation__field-error">
          <i class="app-icon-alert"></i>
          {{ 'TWO_FACTOR.TYPE_CODE.INCORRECT' | mTranslate }}
        </p>
      }
    </form>
  }

  @if (maxTriesExceeded) {
    <app-message-error
      type="error"
      [title]="'TRIES_EXCEEDED.TITLE' | mTranslate"
      [message]="'TRIES_EXCEEDED.MESSAGE' | mTranslate" />
  }
  @if (expiredCode) {
    <app-message-error
      class="mb-0"
      type="alert"
      [title]="'TWO_FACTOR.EXPIRED_CODE.TITLE' | mTranslate"
      [message]="'TWO_FACTOR.EXPIRED_CODE.INFO' | mTranslate" />
  }
  @if (!maxTriesExceeded) {
    <p class="mb-0">
      <span>
        {{ 'TWO_FACTOR.SET_CODE.CODE_NOT_RECEIVED' | mTranslate }}
      </span>
      <button
        m-button
        buttonType="ghost"
        data-testid="send-again-button"
        [disabled]="!sendAgainAvailable"
        (click)="resendCode()">
        {{ 'TWO_FACTOR.SET_CODE.SEND_CODE' | mTranslate }}
      </button>
      @if (!sendAgainAvailable) {
        <span>
          {{ 'TWO_FACTOR.SET_CODE.SEND_CODE_TIMER' | mTranslate }}
          {{ timeRemaining$ | async | date: 'mm:ss' }}
        </span>
      }
    </p>
  }
</app-content-modal>
